/* Shared sticky controller for the Uptown and collection bundle bars. */
(function () {
  'use strict';
  if (window.UptownBundleBarLoaded) return;
  window.UptownBundleBarLoaded = true;

  var BAR = '[data-uf-bundlebar], [data-collection-bundlebar]';
  var TWIN = '#shop-the-set .uf-setdeal';
  var STICKY_CHROME = '.shopify-section--header, .shopify-section--announcement-bar';
  var COLLECTION_MAIN = '.shopify-section--main-collection';
  var COLLECTION_GRID = 'product-list[data-collection-total-products]';
  var COLLECTION_LOADER = 'infinite-scroll';
  var shortViewport = window.matchMedia('(max-height: 480px)');
  var inspectorActive = false;

  function eachBar(root, callback) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(BAR)) callback(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(BAR), callback);
  }

  function disconnect(bar, property) {
    if (!bar[property]) return;
    bar[property].disconnect();
    bar[property] = null;
  }

  function syncOffset(bar) {
    var root = getComputedStyle(document.documentElement);
    var header = document.querySelector('.shopify-section--header');
    var announcement = document.querySelector('.shopify-section--announcement-bar');
    var offset = 0;

    // The page's sticky-height token is 0, so use the rendered sticky chrome.
    if (header && parseFloat(root.getPropertyValue('--header-is-sticky'))) offset += header.offsetHeight;
    if (announcement && parseFloat(root.getPropertyValue('--announcement-bar-is-sticky'))) offset += announcement.offsetHeight;
    bar.style.setProperty('--uf-bar-top', offset + 'px');
  }

  function collectionHasMoreProducts(bar) {
    var main = bar.ufCollectionMain;
    if (!main) return false;

    var loader = main.querySelector(COLLECTION_LOADER);
    if (!loader || !loader.dataset.next) return false;

    var endText = (loader.dataset.endText || '').trim();
    if (endText && loader.textContent.trim() === endText) return false;

    var grid = main.querySelector(COLLECTION_GRID);
    if (grid) {
      var total = parseInt(grid.dataset.collectionTotalProducts, 10);
      var loaded = grid.querySelectorAll(':scope > product-card').length;
      if (!isNaN(total)) return loaded < total;
    }

    return true;
  }

  function syncCollectionEndState(bar) {
    if (!bar.classList.contains('is-stuck') || bar.classList.contains('is-editor-inspecting') || shortViewport.matches) {
      bar.classList.remove('is-ending');
      return;
    }

    var sentinel = bar.ufCollectionEndSentinel;
    var endReached = false;

    if (sentinel && sentinel.isConnected) {
      endReached = sentinel.getBoundingClientRect().top <= window.innerHeight;
    }

    bar.classList.toggle(
      'is-ending',
      endReached && !collectionHasMoreProducts(bar)
    );
  }

  function stopWatchingCollectionEnd(bar) {
    disconnect(bar, 'ufCollectionEndObserver');
    disconnect(bar, 'ufCollectionMutationObserver');
    if (bar.ufCollectionEndFrame) cancelAnimationFrame(bar.ufCollectionEndFrame);
    if (bar.ufCollectionEndSentinel) bar.ufCollectionEndSentinel.remove();
    bar.ufCollectionEndFrame = null;
    bar.ufCollectionEndSentinel = null;
    bar.ufCollectionMain = null;
    bar.classList.remove('is-ending');
  }

  function queueCollectionEndSync(bar) {
    if (bar.ufCollectionEndFrame) return;

    bar.ufCollectionEndFrame = requestAnimationFrame(function () {
      bar.ufCollectionEndFrame = null;

      if (!bar.ufCollectionEndSentinel || !bar.ufCollectionEndSentinel.isConnected) {
        watchCollectionEnd(bar);
        return;
      }

      syncCollectionEndState(bar);
    });
  }

  function watchCollectionEnd(bar) {
    if (!bar.matches('[data-collection-bundlebar]')) {
      stopWatchingCollectionEnd(bar);
      return;
    }

    var main = document.querySelector(COLLECTION_MAIN);
    if (!main) {
      stopWatchingCollectionEnd(bar);
      return;
    }
    if (bar.ufCollectionMain === main && bar.ufCollectionEndSentinel && bar.ufCollectionEndSentinel.isConnected) {
      syncCollectionEndState(bar);
      return;
    }

    stopWatchingCollectionEnd(bar);
    bar.ufCollectionMain = main;
    bar.ufCollectionEndSentinel = document.createElement('span');
    bar.ufCollectionEndSentinel.className = 'collection-bundle-bar__end-sentinel';
    bar.ufCollectionEndSentinel.setAttribute('aria-hidden', 'true');
    main.appendChild(bar.ufCollectionEndSentinel);

    bar.ufCollectionEndObserver = new IntersectionObserver(function () {
      syncCollectionEndState(bar);
    });
    bar.ufCollectionEndObserver.observe(bar.ufCollectionEndSentinel);

    bar.ufCollectionMutationObserver = new MutationObserver(function () {
      queueCollectionEndSync(bar);
    });
    bar.ufCollectionMutationObserver.observe(main, {
      attributes: true,
      attributeFilter: ['data-collection-total-products', 'data-next'],
      childList: true,
      subtree: true
    });

    syncCollectionEndState(bar);
  }

  function setup(bar) {
    if (bar.dataset.ufBound) return true;

    var slot = bar.querySelector('.uf-bundlebar__slot, .collection-bundle-bar__slot');
    var sentinel = bar.querySelector('.uf-bundlebar__sentinel, .collection-bundle-bar__sentinel');
    if (!slot || !sentinel) return false;

    bar.dataset.ufBound = '1';
    bar.classList.toggle('is-editor-inspecting', inspectorActive);

    if (window.ResizeObserver) {
      bar.ufSlotResizeObserver = new ResizeObserver(function (entries) {
        bar.style.setProperty('--uf-bar-h', entries[0].contentRect.height + 'px');
      });
      bar.ufSlotResizeObserver.observe(slot);
    } else {
      bar.style.setProperty('--uf-bar-h', slot.offsetHeight + 'px');
    }

    bar.ufPinObserver = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      bar.classList.toggle('is-stuck', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      syncCollectionEndState(bar);
    });
    bar.ufPinObserver.observe(sentinel);
    return true;
  }

  function watchStickyChrome(bar) {
    disconnect(bar, 'ufChromeResizeObserver');
    syncOffset(bar);
    if (!window.ResizeObserver) return;

    var chrome = document.querySelectorAll(STICKY_CHROME);
    if (!chrome.length) return;

    bar.ufChromeResizeObserver = new ResizeObserver(function () { syncOffset(bar); });
    Array.prototype.forEach.call(chrome, function (element) {
      bar.ufChromeResizeObserver.observe(element);
    });
  }

  function stopWatchingTwin(bar) {
    disconnect(bar, 'ufTwinObserver');
    bar.ufTwin = null;
    bar.classList.remove('is-hidden');
  }

  function watchTwin(bar) {
    if (!bar.matches('[data-uf-bundlebar]')) {
      stopWatchingTwin(bar);
      return;
    }

    var twin = document.querySelector(TWIN);
    if (!twin) {
      stopWatchingTwin(bar);
      return;
    }
    if (bar.ufTwin === twin) return;

    stopWatchingTwin(bar);
    bar.ufTwin = twin;

    // The oversized top margin also covers anchor jumps and the page below the twin.
    bar.ufTwinObserver = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-hidden', entries[entries.length - 1].isIntersecting);
    }, { rootMargin: '100000px 0px 0px 0px' });
    bar.ufTwinObserver.observe(twin);
  }

  function teardown(bar) {
    disconnect(bar, 'ufSlotResizeObserver');
    disconnect(bar, 'ufChromeResizeObserver');
    disconnect(bar, 'ufPinObserver');
    stopWatchingTwin(bar);
    stopWatchingCollectionEnd(bar);
    bar.removeAttribute('data-uf-bound');
    bar.classList.remove('is-stuck', 'is-ending', 'is-editor-inspecting');
    bar.style.removeProperty('--uf-bar-h');
    bar.style.removeProperty('--uf-bar-top');
  }

  function init() {
    if (!window.IntersectionObserver) return;
    eachBar(document, function (bar) {
      if (!setup(bar)) return;
      watchStickyChrome(bar);
      watchTwin(bar);
      watchCollectionEnd(bar);
    });
  }

  function setInspectorState(active) {
    inspectorActive = active;
    eachBar(document, function (bar) {
      bar.classList.toggle('is-editor-inspecting', active);
      syncCollectionEndState(bar);
    });
  }

  function syncViewportState() {
    eachBar(document, syncCollectionEndState);
  }

  if (shortViewport.addEventListener) {
    shortViewport.addEventListener('change', syncViewportState);
  } else {
    shortViewport.addListener(syncViewportState);
  }

  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    eachBar(event.target, teardown);

    if ((event.target.matches && event.target.matches(TWIN)) || event.target.querySelector(TWIN)) {
      eachBar(document, stopWatchingTwin);
    }

    if ((event.target.matches && event.target.matches(STICKY_CHROME)) || event.target.querySelector(STICKY_CHROME)) {
      eachBar(document, function (bar) { disconnect(bar, 'ufChromeResizeObserver'); });
      window.setTimeout(function () { eachBar(document, watchStickyChrome); }, 0);
    }
  });
  document.addEventListener('shopify:inspector:activate', function () { setInspectorState(true); });
  document.addEventListener('shopify:inspector:deactivate', function () { setInspectorState(false); });
  document.addEventListener('theme:loading:end', function () {
    eachBar(document, watchCollectionEnd);
  });
})();
